module.exports = __webpack_public_path__ + "5c50159d11c5bd8b37f0fd1be1262874.svg";